/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import type { Listable } from '@zcode/state-type'
import { format, parse } from 'date-fns'
import { logger } from '../../../../../logger'

export const getDateAvailableText = (listable: Pick<Listable, 'dateAvailable'>) => {
  if (listable.dateAvailable) {
    try {
      const dateAvailableDate = parse(listable.dateAvailable, 'yyyy/MM/dd', new Date())
      return format(dateAvailableDate, 'MMM d')
    } catch (e) {
      logger.info('unable to parse dateAvailable field from listable', listable.dateAvailable, e)
    }
  }
  return undefined
}
